export interface SprintIssue {
  id: number;
  subject: string;
  dueDate: Date | null;

  estimatedHours: number;
  spentHours: number;

  assigneeId: number | null;
  assigneeLogin: string | null;

  accountName: string | null;

  status: string;
  isClosed: boolean;

  epicId: number;
  epicSubject: string;
  epicTags: string[];
}

export function SprintIssueFromJSON(json: any): SprintIssue {
  const status = json.status ?? {};
  const epic = json.epic ?? {};

  return {
    id: json.id,
    subject: json.subject,
    dueDate: json.dueDate ? new Date(json.dueDate) : null,

    estimatedHours: json.estimatedHours ?? 0,
    spentHours: json.spentHours ?? 0,

    assigneeId: json.assignee?.id ?? null,
    assigneeLogin: json.assignee?.login ?? null,

    accountName: json.account ?? null,

    status: status.name ?? "",
    isClosed: Boolean(status.isClosed),

    epicId: epic.id ?? 0,
    epicSubject: epic.subject ?? "",
    epicTags: Array.isArray(epic.tags) ? epic.tags : [],
  };
}
